import { BaseService } from './base-service';
export class CustomListService {
    // ----------------------------------------------------------------------
    // Custom List Schemas
    // ----------------------------------------------------------------------
    static getCustomListSchemas() {
        return BaseService.get(`custom-list/schemas`);
    }
    static saveCustomListSchema(item) {
        return BaseService.save(`custom-list/schemas`, item);
    }
    static deleteCustomListSchema(oid) {
        return BaseService.delete(`custom-list/schemas/${oid}`);
    }
    // ----------------------------------------------------------------------
    // Custom List Values
    // ----------------------------------------------------------------------
    static getCustomListValues(schemaId) {
        return BaseService.get(`custom-list/values/${schemaId}`);
    }
    static saveCustomListValue(item) {
        return BaseService.save(`custom-list/values`, item);
    }
    static deleteCustomListValue(oid) {
        return BaseService.delete(`custom-list/values/${oid}`);
    }
    // ----------------------------------------------------------------------
    // Search Dropdown
    // ----------------------------------------------------------------------
    static searchCustomListSchemaCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return BaseService.get(`custom-list/search-schemas/${selfId}?search=${qs}`);
    }
    static searchCustomListValueCombo(schemaId, selfId, search) {
        let qs = encodeURIComponent(search);
        return BaseService.get(`custom-list/search-values/${schemaId}/${selfId}?search=${qs}`);
    }
}
